/**
 * Created by tiedong on 2017/6/28.
 */
import { handleActions } from 'redux-actions'
import * as types from '../constants/ActionTypes'

const reducers = {}
const initialState = {
    call:{}
}
export default handleActions(reducers,initialState)